
export const columnsDefault = [
    {
        name: 'User ID',
        selector: row => row.uuid,
        width: '150px',
        maxWidth: '150px',
    },
    {
        name: 'Tên',
        selector: row => row.name,
        width: '170px',
        maxWidth: '180px',
    },
    {
        name: 'Email',
        selector: row => row.email,
    }
];

export const columnsFilter = [
    {
        id: "stt",
        name: "STT"
    },
    {
        id: "live",
        name: "Live"
    },
    {
        id: "uuid",
        name: "User ID"
    },
    {
        id: "name",
        name: "Tên"
    },
    {
        id: "group",
        name: "Nhóm"
    },
    {
        id: "email",
        name: "Email"
    },
    {
        id: "2fa",
        name: "2FA"
    },
    {
        id: "status_cookie",
        name: "TT Cookies"
    },
    {
        id: "created_at",
        name: "Ngày Thêm"
    },
    {
        id: "updated_at",
        name: "Ngày Mở"
    },
    {
        name : "Ngày Đồng Bộ Nhóm"
    }
]